export default [
  {
    path: 'afiliados/afiliados-statisticas',
    name: 'afiliados-statisticas',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Estatísticas',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Afiliados', link: 'afiliados' },
        { name: 'Estatísticas' },
      ]
    }
  },
]